export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/hire-banner-bgw-8c804249563c7677bf95f6ba306e80cd.webp";